import Handlebars from 'handlebars/dist/handlebars'

globalThis.Handlebars = Handlebars;
